import { ArrowLeft, ArrowRight } from "react-feather";
import { Button, Tag } from "antd";
import PackingStation from "../PackingStation";

const Step2PackBoxes = ({
  selectedOrderIds = [],
  wegeOrderId,
  loosePackagesCount = 0,
  onBack,
  onProceedToBundle,
  onRefresh,
  t,
}) => {
  return (
    <div>
      {/* Modern Top Action Bar */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "18px",
          padding: "12px 18px",
          backgroundColor: "#f8fafc",
          borderRadius: "10px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 2px 6px rgba(0,0,0,0.02)",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
          <Button
            size="middle"
            onClick={onBack}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              borderRadius: "8px",
              fontWeight: 500,
            }}
          >
            <ArrowLeft size={15} />
            <span>{t("stepper.backToOrders", "Back to Select Orders")}</span>
          </Button>

          {selectedOrderIds.length > 0 && (
            <span style={{ fontSize: "13px", color: "#475569" }}>
              {t("stepper.packingFocusedOrder", "Packing:")}{" "}
              <Tag
                color="blue"
                style={{
                  margin: "0 0 0 4px",
                  fontWeight: 600,
                  borderRadius: "6px",
                  padding: "2px 8px",
                }}
              >
                1688 #{selectedOrderIds.join(", #")}
              </Tag>
            </span>
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {loosePackagesCount > 0 && (
            <span
              style={{
                fontSize: "13px",
                color: "#16a34a",
                fontWeight: 600,
                backgroundColor: "#dcfce7",
                padding: "4px 10px",
                borderRadius: "999px",
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              ✓ {loosePackagesCount} {t("stepper.boxesReady", "box(es) recorded")}
            </span>
          )}

          <Button
            type="primary"
            size="middle"
            disabled={loosePackagesCount === 0}
            onClick={onProceedToBundle}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: 600,
              borderRadius: "8px",
              background: loosePackagesCount > 0
                ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                : undefined,
              boxShadow: loosePackagesCount > 0
                ? "0 4px 12px rgba(16, 185, 129, 0.35)"
                : "none",
              border: "none",
            }}
          >
            <span>{t("stepper.proceedToBundle", "Proceed to Bundle Shipment")}</span>
            <ArrowRight size={15} />
          </Button>
        </div>
      </div>

      {/* Embedded PackingStation */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          border: "1px solid #e2e8f0",
          padding: "12px",
        }}
      >
        <PackingStation
          wegeOrderId={selectedOrderIds.length ? undefined : wegeOrderId}
          alibabaOrderIds={selectedOrderIds.length ? selectedOrderIds : undefined}
          onPackingComplete={() => {}}
          onRefresh={onRefresh}
          onProceedToBundle={onProceedToBundle}
        />
      </div>
    </div>
  );
};

export default Step2PackBoxes;
